import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import { routes } from './routes'
import firebase from 'firebase'
import 'firebase/firestore'
import vueCustomElement from 'vue-custom-element'
import Vuetify from 'vuetify'

Vue.use(VueRouter)
Vue.use(vueCustomElement);

App.router = new VueRouter({ routes })
App.router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser;
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if(requiresAuth && !currentUser) next('login')
  else next()
})

Vue.use(Vuetify, {
  theme:{
      primary: "#F35900",
      secondary: "#373737",
      accent: "#FF6D00",
      error: "#f44336",
      warning: "#ffeb3b",
      info: "#0288D1",
      success: "#4caf50"
    }
})
Vue.customElement('digi-kalk', App);



// WEBPACK FOOTER //
// ./src/main.js